export default "__VITE_ASSET__Bjvd593w__"